import React from 'react';
import { ApolloError } from '@apollo/client';
import { AutocompleteOption } from 'components/inputs/Autocomplete/types.d';
import { RegisterOptions } from 'react-hook-form';

export enum FilterInputType {
  DATE = 'DATE',
  TEXT = 'TEXT',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
}

export interface FilterField {
  type: FilterInputType;
  title: string;
  name: string;
  options?: AutocompleteOption[];
  rules?: RegisterOptions;
  customFilter?: (
    value: string | { id: string; displayName: string },
  ) => string | boolean | string[];
}

export interface FiltersProps {
  filters: FilterField[];
}

export const INPUT_DEFAULT_VALUE: { [key in FilterInputType]: null | '' } = {
  [FilterInputType.DATE]: null,
  [FilterInputType.TEXT]: '',
  [FilterInputType.AUTOCOMPLETE]: null,
};

export interface Identifiable {
  id: string | number;
}

export interface TableColumn<T> {
  title: string;
  render: (data: T) => React.ReactNode;
  sortable?: boolean;
  name: keyof T | string;
}

export interface TableQueryVariables {
  page: number;
  limit: number;
  filter?: Record<string, string>;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface TableLayoutProps<
  T extends Identifiable,
  F extends Record<string, unknown> | undefined = undefined,
> {
  filters?: FilterField[];
  columns: TableColumn<T>[];
  data: T[] | null | undefined;
  loading: boolean;
  error?: ApolloError;
  emptyPlaceholderText: string;
  onRowClick?: (row: T) => void;
  totalCount: number | undefined;
  rowsPerPageText: string;
  refetch: (variables: TableQueryVariables) => void;
  defaultFilter?: F;
}

export interface TableProps<T> {
  columns: TableColumn<T>[];
  data: T[];
  onRowClick?: (row: T) => void;
  totalCount: number | undefined;
  rowsPerPageText: string;
}

export interface TablePaginationProps {
  totalCount: number;
  rowsPerPageText: string;
}
